import * as Sentry from '@sentry/nextjs'
import config from '@config'

const {
  sentry: { DSN, releaseVersion },
  backend: { env },
} = config

Sentry.init({
  dsn: DSN,
  environment: env,
  sampleRate: 0.1,
  tracesSampleRate: 0.1,
  release: releaseVersion,
  allowUrls: [
    /localhost/,
    /webpack/,
    /blick\.ch/,
    /brightcove\.net/,
    /ringier\.ch/,
    /scribblelive\.com/,
  ],
})
